import React from 'react';

function storageKey(wsName: string): string {
  return `sariz:properties-open:${wsName}`;
}

/**
 * Collapsed/expanded state for the Properties panel, remembered per workspace.
 * Defaults to closed.
 */
export function usePropertiesOpen(wsName: string | undefined) {
  const key = wsName ? storageKey(wsName) : undefined;
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (!key) {
      setOpen(false);
      return;
    }
    try {
      setOpen(window.localStorage.getItem(key) === '1');
    } catch {
      setOpen(false);
    }
  }, [key]);

  const setOpenPersistent = React.useCallback(
    (next: boolean | ((previous: boolean) => boolean)) => {
      setOpen((previous) => {
        const value = typeof next === 'function' ? next(previous) : next;
        if (key) {
          try {
            window.localStorage.setItem(key, value ? '1' : '0');
          } catch {
            // Ignore quota / private-mode failures; in-memory state still works.
          }
        }
        return value;
      });
    },
    [key],
  );

  return [open, setOpenPersistent] as const;
}
